import React from 'react'
import imageOne from '../../resource/talks/variusteachers/1.png'
import imageThree from '../../resource/talks/variusteachers/2.png'
import imageTwo from '../../resource/talks/ourteacher/4.png'
import imageFive from '../../resource/talks/ourteacher/5.png'
import { useNavigate } from "react-router-dom";
import TitleChnage from '../../Hook/TitleChnage'

const VariusTeachers = () => {
    TitleChnage("Varius Teachers");
    
    const navigate = useNavigate();
    const handleClick = (event) => {
      const pathMap = {
        variousTeachersTalk: "/variousTeachersTalk",
      };
  
      const path = event.currentTarget.id;
      const targetPath = pathMap[path];
  
      if (targetPath) {
        navigate(targetPath);
      }
    };
  return (
    <div className="dmmatalkVteahcer-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main p-4 mt-4'>Various Teachers</h1>

    <div className="poem-1 mt-6 h4-bold">
        <div>
            <p >Let’s find time – and quiet place </p>
            <p >Mindful and calm - with lot of faith </p>
            <p >Will pay the respect – To triple Gem</p>
            <p >Sit on cushion – Ready to listen</p>

            <p className=" mt-5">Dhamma on air – From divine realm </p>
            <p >Paving the path – to gain knowledge  </p>
            <p >Pears through words – grasp the view </p>
            <p >Rise the insight  – Gaining wisdom   </p>

        </div>
    </div>



    <h1 className='font-second p-4 mt-6 text-center'>Damma Talks</h1>

    <p className="h4-bold mt-5 p-4 text-center">You can listen to Dhamma talks delivered by our esteemed resident monks at the Bhaddeka Vihari Monastery through the links provided below.</p>

    <div className='btn-group mt-5 pb-4'>  
        <img src={imageTwo} alt="Right Top Image" className='curser-pointer' width={300} id='variousTeachersTalk' onClick={handleClick} />
        </div>
        <div className='btn-group mt-5'>  
        <img src={imageFive} alt="Right Top Image" width={300} />
        </div>
        <div className="bottom-box mt-6 ">
        <img src={imageThree} alt="bottom-image" width={600} />
    </div>
</div>
  )
}

export default VariusTeachers
